import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Google Analytics Api React Component
 * Max Makh.
 */
const GTAG_URL = 'https://www.googletagmanager.com/gtag/js';

class GoogleAnalyticsApi extends Component {
  componentDidMount() {
    const { googleAnalyticsTrackingId } = this.props;

    if (!googleAnalyticsTrackingId) {
      return;
    }

    this.getGoogleAnalyticsApi().then(() => {
      // console.info('Google Analytics API has finished loading.');
      this.injectGoogleAnalyticsConfigScript();
    });
  }

  getGoogleAnalyticsApi() {
    if (!this.googleAnalyticsPromise) {
      this.googleAnalyticsPromise = new Promise((resolve) => {
        window.resolveGoogleAnalyticsApi = () => {
          resolve();
          delete window.resolveGoogleAnalyticsApi;
        };

        // Load the Google Analytics API
        const script = document.createElement('script');
        const { googleAnalyticsTrackingId } = this.props;

        script.src = `${GTAG_URL}?id=${googleAnalyticsTrackingId}`;
        script.async = true;
        script.onload = window.resolveGoogleAnalyticsApi;
        document.body.appendChild(script);
      });
    }
    return this.googleAnalyticsPromise;
  }

  getScriptContent = googleAnalyticsTrackingId => `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${googleAnalyticsTrackingId}');
  `;

  injectGoogleAnalyticsConfigScript() {
    const { googleAnalyticsTrackingId } = this.props;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    const content = document.createTextNode(this.getScriptContent(googleAnalyticsTrackingId));
    script.appendChild(content);
    document.head.appendChild(script);
  }

  render() {
    return null;
  }
}

GoogleAnalyticsApi.propTypes = {
  googleAnalyticsTrackingId: PropTypes.string.isRequired,
};

export default GoogleAnalyticsApi;



// WEBPACK FOOTER //
// ./src/components/GoogleAnalyticsApi/GoogleAnalyticsApi.js